module.exports = __webpack_public_path__ + "static/media/18_r_ugol_80.99_15.65.ba476210.png";